import React, { useEffect, useMemo, useState } from "react";
import {
  API_SECURE_KEY,
  IDIGIZEN_BACKEND_URL,
  IDIGIZEN_FRONTEND_URL,
  bhpEditLinks,
  getFileThumbnailDB,
  getPageType,
  whatsappMessage,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import {
  IonAvatar,
  IonButton,
  IonFooter,
  IonIcon,
  IonImg,
  IonInput,
  IonItem,
  IonLabel,
  IonPopover,
} from "@ionic/react";
import "./styles/BhpDirectoryCard.css";
// import "../UI/ImageExpanderModal";
import {
  add,
  arrowForward,
  call,
  callOutline,
  card,
  cardOutline,
  caretForward,
  chevronForward,
  close,
  globeOutline,
  logoWhatsapp,
  navigate,
  pencil,
  pricetag,
  pricetagOutline,
  pricetagSharp,
  search,
  starOutline,
} from "ionicons/icons";
import {
  BhpMarketTypes,
  BhpThemeHeaderWithBack,
  SeoUrlDetailsType,
  SubscriptionType,
} from "../pages/BussinessHomePage";
import { getSeoUrl, getValidWhatsAppPhone } from "../common/commonFunctions";
import {
  AdvertisingDetailsType,
  AlertWithoutExecTypes,
  PositionType,
} from "../types/data_types";
import AlertWithoutExec from "../UI/AlertWithoutExec";
import { setOptions } from "react-chartjs-2/dist/utils";
import { useMap } from "react-leaflet";
import ContentWithBackground from "../UI/ContentWithBackground";
import { useHistory } from "react-router";
import { SEPARATOR_MULTI_INPUT } from "../types/form_table_data_types";
import BhpCategoryCard from "./BhpCategoryCard";
import {
  useAppSelector,
  useRecordUserInteractions,
  userActionsTable,
} from "../app/hooks";

const BhpDirectoryCard: React.FC<{
  phone: string;
  adMaker?: boolean;
  fileName: string;
  title: string;
  subTitle: string;
  subscriptionType?: SubscriptionType;
  address?: string;
  hasSpecials?: boolean;
  marketDomain: string;
  shopDomain: string;
  imgObj: { fileName: string; rotation: number; imgCss: string };
  dismiss?: () => void;
  marketId?: string;
  shopId?: string;
  stockImg?: string;
  adData?: AdvertisingDetailsType[];
  searchText?: string;
  seoUrlDetails?: SeoUrlDetailsType;
  recordUserInteractions?: boolean;
  marketType?: BhpMarketTypes;
  pageId?: string | number;
  pageSection?: "MAIN" | "SEARCH";
  search?: string;
  location?: PositionType;
  locationUrl?: string;
  floorId?: number;
  rating?: string | number;
  navigate?: (
    location: { obj?: PositionType; url?: string },
    shopId: string,
    shopName: string
  ) => void;
}> = (props) => {
  const { token } = getSessionDetails();
  const AUTH_PARAMS = `token=${token}&Authorization=${API_SECURE_KEY}`;
  const value = {
    fileName: props.fileName ? props.fileName : "",
    imgCss: "",
  };
  const imgUrl = !!value.fileName
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${value.fileName}&percentage=40&${AUTH_PARAMS}&`
    : !!props.stockImg
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${
        JSON.parse(props.stockImg).fileName
      }&percentage=40&${AUTH_PARAMS}&`
    : props.imgObj?.fileName
    ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${props.imgObj.fileName}&percentage=40&${AUTH_PARAMS}&`
    : "assets/shop.avif";

  // const buttonCss =
  //   props.subscriptionType === "NONE"
  //     ? "bhp-directory-details-button-details"
  //     : props.subscriptionType === "VCARD"
  //     ? "bhp-directory-details-button-contact"
  //     : "bhp-directory-details-button-online";
  const highlightText = (text: string, addButton: boolean = false) => {
    const exploreHtml = addButton
      ? '<span style="background-color: lightgray; color: gray; padding: 2px 5px; font-size: 0.6rem; margin-left: 5px; border-radius: 5px;">Explore</span>'
      : "";
    if (!text) return exploreHtml;
    // else text += exploreHtml;
    if (!props.searchText) {
      return `${text}${exploreHtml}`;
    }

    const regex = new RegExp(props.searchText, "gi");
    const retVal = text.replace(
      regex,
      (match) => `<span style="background-color: yellow;">${match}</span>`
    );
    return `${retVal}${exploreHtml}`;
  };

  const recordAction = useRecordUserInteractions();

  const openWhatsapp = () => {
    if (!phoneNumbers.length) {
      setAlert({
        open: true,
        message: "This shop does not have a phone number listed",
      });
      return;
    }
    if (props.recordUserInteractions) {
      recordAction({
        action: userActionsTable.whatsapp,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(!!props.marketType, props.marketType),
        notes: props.search,
        popId: props.shopId,
        popType: !props.search ? "SHOP" : "SEARCHED_SHOP",
      });
    }
    whatsappMessage(
      "Hello! I found your business on VypZee.com.",
      phoneNumbers[0]
    );
    // const whatsappUrl = `https://api.whatsapp.com/send?phone=91${getValidWhatsAppPhone(
    //   phoneNumbers[0]
    // )}`;
    // window.open(whatsappUrl, "_system");
  };

  const openPhoneCall = () => {
    if (!phoneNumbers.length) {
      setAlert({
        open: true,
        message: "This shop does not have a phone number listed",
      });
      return;
    }
    if (props.recordUserInteractions) {
      recordAction({
        action: userActionsTable.call,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(!!props.marketType, props.marketType),
        notes: props.search,
        popId: props.shopId,
        popType: !props.search ? "SHOP" : "SEARCHED_SHOP",
      });
    }
    console.log(`Phone number call `, phoneNumbers[0]);
    window.open(`tel:${phoneNumbers[0]}`);
  };

  const [alert, setAlert] = useState<AlertWithoutExecTypes>({
    message: "",
    open: false,
  });

  const phoneNumbers: string[] = useMemo(() => {
    if (!props.phone) return [];
    // console.log("Shop ", props.shopDomain, "Input phone ", props.phone);
    const intermediate = props.phone.split(",").map((el) => el.trim());
    const retVal = [];
    for (const el of intermediate) {
      const nums = el.split(SEPARATOR_MULTI_INPUT);
      for (const item of nums) {
        retVal.push(item.trim());
      }
    }
    return retVal;
  }, [props.phone]);

  // const [showDetails, setShowDetails] = useState(false);

  // const callButtonJsx = (
  //   <div
  //     className="bhp-directory-button"
  //     style={{
  //       marginBottom: "15px",
  //       color: phoneNumbers.length
  //         ? "var(--ion-color-tertiary)"
  //         : "var(--ion-color-medium)",
  //     }}
  //     onClick={(e) => {
  //       e.stopPropagation();
  //       openPhoneCall();
  //     }}
  //   >
  //     <IonIcon icon={call} />
  //   </div>
  // );

  // const whatsappButtonJsx = (
  //   <div
  //     className="bhp-directory-button"
  //     style={{
  //       color: phoneNumbers.length
  //         ? "var(--ion-color-primary)"
  //         : "var(--ion-color-medium)",
  //     }}
  //     onClick={(e) => {
  //       e.stopPropagation();
  //       openWhatsapp();
  //     }}
  //   >
  //     <IonIcon icon={logoWhatsapp} />
  //   </div>
  // );

  // const navigateButtonJsx = (
  //   <div
  //     className="bhp-directory-button"
  //     style={{
  //       color:
  //         props.floorId || props.location
  //           ? "var(--ion-color-orange)"
  //           : "var(--ion-color-medium)",
  //       marginTop: "15px",
  //     }}
  //     onClick={(e) => {
  //       e.stopPropagation();
  //       if (!(props.floorId || props.location)) {
  //         setAlert({
  //           open: true,
  //           message: "Navigation is not enabled for this shop",
  //         });
  //         return;
  //       }
  //       // props?.dismiss();
  //       // setTimeout(() => {
  //       //   window.location.assign(
  //       //     `${IDIGIZEN_FRONTEND_URL}/navigation?marketId=${props.marketId}&destinationShopId=${props.shopId}`
  //       //   );
  //       // }, 500);
  //       props?.navigate(props.location, props.shopId, props.title);
  //     }}
  //   >
  //     <IonIcon icon={navigate} />
  //   </div>
  // );

  // const shopDetailsJsx = (
  //   <IonPopover
  //     className="bhp-directory-details-popover"
  //     isOpen={showDetails}
  //     onDidDismiss={() => {
  //       setShowDetails(false);
  //     }}
  //   >
  //     <BhpThemeHeaderWithBack
  //       onBack={() => {
  //         setShowDetails(false);
  //       }}
  //       title={"Store Details"}
  //     />
  //     <ContentWithBackground>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"tertiary"}>
  //           Name
  //         </IonLabel>
  //         <IonInput readonly={true} value={props.title} />
  //       </IonItem>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"tertiary"}>
  //           Details
  //         </IonLabel>
  //         <IonInput readonly={true} value={props.subTitle} />
  //       </IonItem>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"tertiary"}>
  //           Phone(s)
  //         </IonLabel>
  //         <IonInput readonly={true} value={props.phone} />
  //       </IonItem>
  //       <IonItem>
  //         <IonLabel position="stacked" color={"tertiary"}>
  //           Address
  //         </IonLabel>
  //         <IonInput readonly={true} value={props.address} />
  //       </IonItem>
  //     </ContentWithBackground>
  //     <IonFooter>
  //       <div style={{ padding: "5px" }}>
  //         <div></div>
  //         <div style={{ display: "flex", justifyContent: "space-evenly" }}>
  //           <div style={{ padding: "15px 10px" }}>{callButtonJsx}</div>
  //           <div style={{ padding: "15px 10px" }}>{whatsappButtonJsx}</div>
  //           <div style={{ padding: "15px 10px" }}>{navigateButtonJsx}</div>
  //         </div>
  //         <IonButton
  //           expand="block"
  //           color={"danger"}
  //           onClick={setShowDetails.bind(this, false)}
  //         >
  //           <IonIcon slot="start" icon={close} />
  //           Dismiss
  //         </IonButton>
  //       </div>
  //     </IonFooter>
  //   </IonPopover>
  // );

  // const history = useHistory();

  const cardClick = () => {
    if (props.recordUserInteractions) {
      recordAction({
        action: userActionsTable.visitPage,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(!!props.marketType, props.marketType),
        notes: props.search,
        popId: props.shopId,
        popType: !props.search ? "SHOP" : "SEARCHED_SHOP",
      });
    }
    // if (!props.shopDomain) {
    //   setShowDetails(true);
    // } else {
    // window.location.assign(
    //   `https://${props.marketDomain}.vypzee.com/business/${props.shopDomain}`
    // );
    // history.push(`/business/${props.shopDomain}`);
    // }
    window.location.assign(getSeoUrl(props?.seoUrlDetails));
  };

  // const cardCss =
  //   props.subscriptionType === "TIER-II"
  //     ? "bhp-directory-card-online"
  //     : props.subscriptionType === "TIER-I"
  //     ? "bhp-directory-card-catalog"
  //     : props.subscriptionType === "VCARD"
  //     ? "bhp-directory-card-contact"
  //     : "";

  // const [currentAdIdx, setCurrentAdIdx] = useState<number>(0);

  // useEffect(() => {}, [props?.adData]);
  const maxLength = 80;
  const editMode = useAppSelector(
    (state) => state.loginInfoSelection.bhpEditMode
  );

  const directoryButtonsJsx = (
    <>
      <div style={{ width: "33%" }}>
        <IonButton
          expand="block"
          size="small"
          color={!phoneNumbers?.length ? "medium" : "tertiary"}
          onClick={(e) => {
            e.stopPropagation();
            openPhoneCall();
          }}
        >
          <IonIcon icon={call} />
        </IonButton>
      </div>
      <div style={{ width: "33%" }}>
        <IonButton
          expand="block"
          size="small"
          color={!phoneNumbers?.length ? "medium" : "primary"}
          onClick={(e) => {
            e.stopPropagation();
            openWhatsapp();
          }}
        >
          <IonIcon icon={logoWhatsapp} />
        </IonButton>
      </div>
      <div style={{ width: "33%" }}>
        <IonButton
          expand="block"
          size="small"
          color={"secondary"}
          onClick={(e) => {
            e.stopPropagation();
            console.log(
              "Navigate button clicked",
              props.location,
              props.locationUrl
            );
            if (!(props.floorId || props.location || props.locationUrl)) {
              setAlert({
                open: true,
                message: "Navigation is not enabled for this shop",
              });
              return;
            }
            // props?.dismiss();
            // setTimeout(() => {
            //   window.location.assign(
            //     `${IDIGIZEN_FRONTEND_URL}/navigation?marketId=${props.marketId}&destinationShopId=${props.shopId}`
            //   );
            // }, 500);
            // return;
            props?.navigate(
              { obj: props.location, url: props.locationUrl },
              props.shopId,
              props.title
            );
          }}
        >
          <IonIcon icon={navigate} />
        </IonButton>
      </div>
    </>
  );
  const history = useHistory();

  return (
    <>
      {/* {shopDetailsJsx} */}
      <AlertWithoutExec openAlert={alert} setOpenAlert={setAlert} />
      <div className="bhp-directory-top">
        <div className={`bhp-directory-card`}>
          {/* {(props.hasSpecials || !!props.adData.length) && (
            <div className="selection-list-offer-ribbon">
              <div
                className={`selection-list-offer-ribbon-text ${
                  !props.hasOffers
                    ? "selection-list-offer-ribbon-text-special"
                    : "selection-list-offer-ribbon-text-offer"
                }`}
              >
                {props.hasOffers
                  ? `${props?.adData?.length} Offers`
                  : "Specials"}
              </div>
            </div>
          )} */}
          {/* <div
            className="bhp-directory-details-button-wrpr"
            onClick={cardClick}
          >
            <div className={`bhp-directory-details-button ${buttonCss}`}>
              {(props.subscriptionType === "TIER-I" ||
                props.subscriptionType === "TIER-II") && (
                <>
                  <IonIcon icon={globeOutline} />{" "}
                  <span style={{ marginLeft: "3px" }}>Online</span>
                </>
              )}
              {props.subscriptionType === "VCARD" && (
                <>
                  <IonIcon icon={cardOutline} />
                  <span style={{ marginLeft: "3px" }}>Details</span>
                </>
              )}
              {props.subscriptionType === "NONE" && (
                <>
                  <IonIcon icon={add} />
                  <span style={{ marginLeft: "3px" }}>Expand</span>
                </>
              )}
            </div>
            {props.hasOffers && (
              <div
                className={`bhp-directory-details-button bhp-directory-details-button-offer`}
              >
                <>
                  <IonIcon icon={pricetagOutline} />
                  <span style={{ marginLeft: "3px" }}>Offers</span>
                </>
              </div>
            )}
            {props.hasSpecials && (
              <div
                className={`bhp-directory-details-button bhp-directory-details-button-specials`}
              >
                <>
                  <IonIcon icon={starOutline} />
                  <span style={{ marginLeft: "3px" }}>Specials</span>
                </>
              </div>
            )}
          </div> */}
          <div className="bhp-directory-info" onClick={cardClick}>
            {/* <IonAvatar
              className={`${value.imgCss} bhp-directory-list-avatar  ${cardCss}`}
            >
              <IonImg src={imgUrl} />
            </IonAvatar> */}
            <BhpCategoryCard
              imgFileUrl={imgUrl}
              style={{ borderRadius: "0" }}
              rating={props?.rating}
              // name="Click To Visit Page"
              // name={
              //   props.subscriptionType === "NONE" ||
              //   props.subscriptionType === "VCARD"
              //     ? "View Store Details"
              //     : "View Online Catalogue"
              // }
            />
            <div className="bhp-directory-textarea">
              <div
                className="bhp-ad-ribbon"
                style={{
                  background:
                    !props.adData || !props.adData.length
                      ? "transparent"
                      : undefined,
                  color:
                    !props.adData || !props.adData.length
                      ? "transparent"
                      : undefined,
                }}
              >
                {!!props.adData && !!props.adData.length && (
                  <>
                    <div className="bhp-ad-ribbon-text-wrpr">
                      <div
                        className="bhp-ad-ribbon-text"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        // style={{ animation: "scroll-left 5s linear infinite" }}
                      >
                        {props.adData.map((el) => {
                          return (
                            <>
                              <span style={{ paddingRight: "5px" }}>
                                <IonIcon icon={pricetagSharp} />
                              </span>
                              {`${el.title}${
                                !!el.subTitle && el.subTitle !== "null"
                                  ? ` - ${el.subTitle}`
                                  : ""
                              }`}
                              <span style={{ paddingRight: "20px" }}></span>
                            </>
                          );
                        })}
                        <span style={{ paddingRight: "20px" }}></span>
                      </div>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        top: "6px",
                        right: "5px",
                        background: "white",
                      }}
                    >
                      <IonIcon icon={caretForward} />
                    </div>
                  </>
                )}
                {(!props.adData || !props.adData.length) && <div>Test</div>}
              </div>
              <div
                style={{
                  flexGrow: "1",
                  padding: "5px 10px",
                }}
              >
                {/* <div className="bhp-directory-title">{props.title}</div> */}
                <div
                  className="bhp-directory-title"
                  dangerouslySetInnerHTML={{
                    __html: highlightText(props.title),
                  }}
                />
                {/* <div className="bhp-directory-subtitle">{props.subTitle}</div> */}
                <div
                  className="bhp-directory-subtitle"
                  dangerouslySetInnerHTML={{
                    __html: highlightText(
                      props.subTitle?.length > maxLength
                        ? `${props.subTitle.slice(0, maxLength)}...`
                        : props.subTitle,
                      true
                    ),
                  }}
                />
              </div>
            </div>
            {/* <div className="bhp-directory-buttons-border"></div> */}
            {/* <div className="bhp-directory-buttons">
              <div>
                <IonIcon icon={chevronForward} />
              </div>
            </div> */}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              padding: "5px",
              // borderTop: "1px solid lightgray",
            }}
          >
            {!editMode && directoryButtonsJsx}
            {!!editMode && (
              <div style={{ flexGrow: "1" }}>
                <IonButton
                  expand="block"
                  color={"tertiary"}
                  onClick={() => {
                    history.goBack();
                    setTimeout(() => {
                      history.push(
                        bhpEditLinks.editShop.replace(
                          "%SCHOOL_ID%",
                          `${props.shopId}`
                        )
                      );
                    }, 500);
                  }}
                >
                  <IonIcon icon={pencil} />
                </IonButton>
              </div>
            )}
          </div>
        </div>
      </div>
      {!!props.adMaker && (
        <IonButton
          onClick={() => {
            whatsappMessage(
              `Create your ad by clicking: 
          https://market.vypzee.com/create-ad?domain=${props.shopDomain}
          `,
              phoneNumbers[0]
            );
          }}
        >
          <IonIcon icon={logoWhatsapp} slot="start" />
          Create Ad Link{" "}
        </IonButton>
      )}
    </>
  );
};

export default BhpDirectoryCard;
